import React from "react";
import HeroSection from "components/Home/HeroSection";
import FeatureCarousel from "components/Home/FeatureCarousel";
import IndustryCarousel from "components/Home/IndustryCarousel";
import CTASection from "components/Home/CTASection";
import MKBox from "components/MKBox";

export default function Home() {
  return (
    <>
      {/* Hero Section */}
      <HeroSection />

      {/* Features & Industries Section */}
      <MKBox id="features" py={10}>
        <FeatureCarousel />
        <IndustryCarousel />
      </MKBox>

      {/* Call-to-Action Section */}
      <MKBox id="cta" py={10}>
        <CTASection />
      </MKBox>
    </>
  );
}
